import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="h-full flex justify-center items-center" data-testid="not-found-page">
      <div className="max-w-md w-full space-y-6 text-center">
        <h1 className="text-2xl font-semibold">{t('notFound.title')}</h1>
        <p className="text-muted-foreground">{t('notFound.message')}</p>
        <div className="flex items-center justify-center gap-3">
          <Button onClick={() => navigate('/')} data-testid="not-found-page-go-home-button">
            {t('notFound.goHome')}
          </Button>
        </div>
      </div>
    </div>
  );
}
